/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import { message } from 'antd';
import React, { HTMLProps, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useTimer } from 'react-timer-hook';

import { GeneralException } from '~/exceptions/generalException';
import { ABANDONED_PAGE_ROUTE, ERROR_PAGE_ROUTE } from '~/routing/routes';
import { PaymentService } from '~/services/PaymentService';
import { logger } from '~/utils/func/logger';
import { isTransactionNotFoundError } from '~/utils/paymentResultUtils';
import './ConsumerAuthenticationForm.scss';

export interface ConsumerAuthenticationFormProps extends HTMLProps<HTMLFormElement> {
  selectedItem?: number;
  loading?: boolean;
  redirect: string;
  accessToken: string;
  setupAuthPaymentBody?: any;
}

const ConsumerAuthenticationForm: React.FC<ConsumerAuthenticationFormProps> = ({
  loading,
  redirect,
  accessToken,
  setupAuthPaymentBody,
}) => {
  const { t } = useTranslation();
  const { push } = useHistory();

  const getTransactionDetails = useCallback(
    async (transactionRef: string) => {
      try {
        const res = await PaymentService.getTransactionDetails(transactionRef);
        const {
          data,
          data: {
            transaction: { status },
          },
        } = res;

        if (data !== null && data !== undefined) {
          logger.debug('status', { prefix: 'ConsumerAuth', data: status });
          logger.debug('transactionRef auth', { prefix: 'ConsumerAuth', data: setupAuthPaymentBody.transactionRef });
          logger.debug("localStorage.getItem('validateDetails')", {
            prefix: 'ConsumerAuth',
            data: localStorage.getItem('validateDetails'),
          });
          // console.log(localStorage.getItem('transactionDetails'), 'transactionDetails auth ');
          switch (status) {
            case 'ACCEPTED':
              window.location.reload(); // push(SUCCESS_PAGE_ROUTE());
              break;
            case 'PAYMENT_ALREADY_PROCESSED':
              window.location.reload(); // Paiement déjà effectué
              break;
            case 'REFUSED': // REFUSED
              window.location.reload(); // push(FAIL_PAGE_ROUTE());
              break;
            case 'REJECTED': // REJECTED
              window.location.reload(); // push(FAIL_PAGE_ROUTE());
              break;
            case 'PENDING':
              break;
            default:
              push(ERROR_PAGE_ROUTE());
              break;
          }
        }
      } catch (error: unknown) {
        if (isTransactionNotFoundError(error)) {
          push(ABANDONED_PAGE_ROUTE());
          return;
        }
        const exception = (error as { response?: { data?: GeneralException } })?.response?.data as GeneralException;
        if (process.env.NODE_ENV === 'development') {
          logger.debug('exception', { prefix: 'ConsumerAuth', data: exception });
        }
        message.error(exception?.description || t('home:global:generalResponse'), 1);
      }
    },
    [push],
  );

  const formulaireRef = useRef<HTMLFormElement>(null);

  const redirectAfterOperation = () => {
    // push(FAIL_PAGE_ROUTE());
    window.location.reload();
    logger.debug('redirectAfterOperation', { prefix: 'ConsumerAuth' });
  };
  const expiryTimestamp = new Date();
  expiryTimestamp.setMinutes(expiryTimestamp.getMinutes() + 30);
  const { seconds, minutes, hours, days, restart } = useTimer({
    onExpire: () => redirectAfterOperation(),
    expiryTimestamp,
  });

  const transactionDetails = useCallback(() => {
    getTransactionDetails(setupAuthPaymentBody.transactionRef);
    logger.debug('transactionDetails poll', { prefix: 'ConsumerAuth' });
  }, [setupAuthPaymentBody.transactionRef]);

  useEffect(() => {
    // console.log('accessToken consumer XXX', accessToken);
    // console.log('redirect consumer XXX', redirect);
    logger.debug('Yves Resolver redirect out', { prefix: 'ConsumerAuth', data: redirect });

    window.addEventListener(
      'message',
      event => {
        logger.debug('Yves Resolver redirect into', { prefix: 'ConsumerAuth', data: redirect });

        logger.debug('event consumer', { prefix: 'ConsumerAuth', data: event });
        logger.debug('event.data consumer', { prefix: 'ConsumerAuth', data: event.data });
        logger.debug('origin consumer', { prefix: 'ConsumerAuth', data: event.origin });
        // localStorage.setItem('collectData', JSON.stringify(event));
        // localStorage.setItem('collectDataEvent', JSON.stringify(event.data));
        if (
          event.origin === 'https://centinelapi.cardinalcommerce.com' ||
          event.origin === 'https://client.cardinaltrusted.com'
        ) {
          // https://centinelapistag.cardinalcommerce.com
          logger.debug('INSIDE CONSUMER event.data', { prefix: 'ConsumerAuth', data: event.data });
          // document.body.style.height = `${event.data}px`;
          // (document.getElementById('step_up_iframe') as HTMLElement).style.height = `${250}px`;
        }
      },
      false,
    );
    if (formulaireRef.current) {
      formulaireRef.current.submit();
    }

    const interval = setInterval(transactionDetails, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [redirect, accessToken, transactionDetails]);

  return (
    <div className="consumer-auth-form">
      {/* <div className={cn('caption-wrapper')}>
        <Text className="caption" size="s" weight={FontWeight.MEDIUM} variant={TextVariants.PRIMARY}>
          {'Consumer Auth infos'}
        </Text>
      </div> */}
      {/* <div className="centered-text">
        <h5>
          {t('bank:timeRemaining')} <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>
        </h5>
      </div> */}

      <div className="form-wrapper">
        <form ref={formulaireRef} id="step_up_form" name="stepup" method="POST" target="stepUpIframe" action={redirect}>
          <input id="step_up_form_jwt_input" type="hidden" name="JWT" value={accessToken} />
        </form>
        <iframe
          name="stepUpIframe"
          id="step_up_iframe"
          style={{
            border: 'none',
            // marginLeft: 'auto',
            // marginRight: 'auto',
            display: 'block',
            width: '100%',
            minHeight: '1000px',
          }}
        ></iframe>

        {/* <iframe id="step_up_iframe" style="border: none; margin-left: auto; margin-right: auto; display: block;"></iframe>
<form id="step_up_form" name="stepup" method="POST" action="https://centinelapistag.cardinalcommerce.com/V2/Cruise/StepUp">
    <input id="step_up_form_jwt_input" type="hidden" name="JWT" value="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJqdGlfNWYwODY4MDA1ZWM3NjUuMTYyNjQwMzUiLCJpYXQiOjE1OTQzODY0MzIsImlzcyI6IjViMjNmOGMwYmY5ZTJmMGQzNDdkZDViYSIsIk9yZ1VuaXRJZCI6IjU1ZWYzZjBjZjcyM2FhNDMxYzk5YjQzOCIsIlJldHVyblVybCI6Imh0dHA6XC9cL2xvY2FsaG9zdDo4MDgyXC9tZlwvcmVkaXJlY3QucGhwIiwiUmVmZXJlbmNlSWQiOiI3OGVlYTM3Zi01OTE0LTRiZmUtYTNiMy1lMzMzNGRiYmU3NDciLCJQYXlsb2FkIjp7IkFDU1VybCI6Imh0dHBzOlwvXC8wbWVyY2hhbnRhY3NzdGFnLmNhcmRpbmFsY29tbWVyY2UuY29tXC9NZXJjaGFudEFDU1dlYlwvY3JlcS5qc3AiLCJQYXlsb2FkIjoiZXlKdFpYTnpZV2RsVkhsd1pTSTZJa05TWlhFaUxDSnRaWE56WVdkbFZtVnljMmx2YmlJNklqSXVNUzR3SWl3aWRHaHlaV1ZFVTFObGNuWmxjbFJ5WVc1elNVUWlPaUpoWVdWbU16Y3lZaTAyWXpZd0xUUXdOVFV0WVdRNE55MDBPVEUyTmpNM1pEVTNZemNpTENKaFkzTlVjbUZ1YzBsRUlqb2lZV1UyT0RsaFl6RXROVEprWkMwMFpqRmlMVGs1TW1RdFpHTmpNRGxsWVdZMFpXUmxJaXdpWTJoaGJHeGxibWRsVjJsdVpHOTNVMmw2WlNJNklqQXlJbjAiLCJUcmFuc2FjdGlvbklkIjoiWlFpZUFFMzBsWFhsSDdBTmhzRTAifSwiT2JqZWN0aWZ5UGF5bG9hZCI6dHJ1ZX0.dAjB55PT-boUc0reG19HhNYO6r8u39DzT0FZ6dDHZEk">
</form> */}
      </div>
    </div>
  );
};

export default ConsumerAuthenticationForm;
